import { render, staticRenderFns } from "./AddNegativeKeywordModal.vue?vue&type=template&id=589df0c8"
import script from "./AddNegativeKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddNegativeKeywordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports